import { render } from "./uploaddocumentpopup.vue?vue&type=template&id=5ed8c3dc&scoped=true"
import script from "./uploaddocumentpopup.vue?vue&type=script&lang=js"
export * from "./uploaddocumentpopup.vue?vue&type=script&lang=js"

import "./uploaddocumentpopup.vue?vue&type=style&index=0&id=5ed8c3dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed8c3dc"]])

export default __exports__